import React, { useState, useEffect } from 'react';
import TopupForm from "./TopupForm";
import { CssBaseline, Container } from "@mui/material";
import "./App.css";

function Reloadly() {

  useEffect(() => {
    document.title = `Reloadly `;
  }, []);


  return (
    <div className="App">
      <CssBaseline />
      <Container style={{ paddingTop: 0, paddingBottom: 2, paddingLeft: 2, paddingRight: 2, }}
        maxWidth="xl"
        sx={{
          paddingTop: 0, paddingBottom: 1,
        }}
      >
        
        <main>
          <TopupForm />
        </main>
      </Container>
    </div>
  );
}

export default Reloadly;